import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchJSON} from '../../../../helpers/FetchUtils';
import {
    PROFILE_LOAD
} from './constants';
import {
    profileLoadFail,
    profileLoadSuccess
} from './actions';
import {catchError} from "../../../../util/ErrorCatchUtils";
import {layoutMainSignCheck} from "../main/actions";

//
function* profileLoad() {
    try {
        const response = yield call(fetchJSON, '/api/account/member/current', {method: 'GET',});
        if (response.success) {
            let responseData = response.data;
            yield put(profileLoadSuccess({loadDatas: {...responseData}}));
        } else {
            // const {errorCode} = response;
            // yield put(layoutMainSignCheck({errorCode}));
            yield put(profileLoadFail(response));
        }
    } catch (error) {
        // const {errorCode, message} = error;
        // yield put(layoutMainSignCheck({errorCode, message, showToast: true}));
        yield put(profileLoadFail(catchError(error)));
    }
}

//
export function* profileLoadWatcher() {
    yield takeEvery(PROFILE_LOAD, profileLoad);
}

//
function* LayoutProfileSaga() {
    yield all([
        fork(profileLoadWatcher)]);
}

//
export default LayoutProfileSaga;
